import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import FeedbackBox from "../components/FeedbackBox";
import { useFeatureAccess } from "../hooks/useFeatureAccess";
import LockedFeature from "../components/LockedFeature";
import STORAGE_KEYS from "../utils/storageKeys";

function ListeningLevel() {
  const { level } = useParams();
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const { canAccess } = useFeatureAccess({ skill: "Listening", level });

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    fetch(`/listening/${level}/index.json`)
      .then((res) => res.json())
      .then(async (data) => {
        if (!mounted) return;

        const baseLessons = Array.isArray(data) ? data : (data?.lessons || []);

        const mergedLessons = await Promise.all(
          baseLessons.map(async (lesson) => {
            try {
              // ✅ FIX: تحويل ID لو كان A1-L1 → lesson1
              let fixedId = lesson.id;
              if (lesson.id && lesson.id.includes("-L")) {
                const num = lesson.id.split("-L")[1];
                fixedId = `lesson${num}`;
              }

              const res = await fetch(`/listening/${level}/${fixedId}/data.json`);

              if (!res.ok) {
                return { ...lesson, id: fixedId };
              }

              const text = await res.text();

              if (!text || text.trim() === "" || text === "{}") {
                return { ...lesson, id: fixedId };
              }

              const realData = JSON.parse(text);

              return {
                ...lesson,
                id: fixedId, // 🔥 مهم جدًا لتصحيح المسار
                title: realData.title || lesson.title,
                description: realData.description || lesson.description
              };
            } catch {
              return lesson;
            }
          })
        );

        setLessons(mergedLessons);
        setLoading(false);
      })
      .catch(() => {
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, [level]);

  if (!canAccess) return <LockedFeature title={`Listening Level ${level}`} />;
  if (loading) return <p style={{ textAlign: "center", padding: "40px" }}>Loading Lessons...</p>;

  const completedLessons = JSON.parse(localStorage.getItem(STORAGE_KEYS.LISTENING_COMPLETED)) || [];

  return (
    <div style={{ maxWidth: "760px", margin: "0 auto", padding: "20px" }}>
      <h2 style={{ marginBottom: "20px" }}>🎧 Level {level} Lessons</h2>

      {lessons.length === 0 && <p>No lessons found.</p>}

      {lessons.map((lesson, index) => {
        const lessonKey = `${level}-${lesson.id}`;
        const isCompleted = completedLessons.includes(lessonKey);

        return (
          <div key={lesson.id} style={cardStyle}>
            <div style={{flex: 1}}>
              <h4 style={{margin: "0 0 5px"}}>
                Lesson {index + 1}: {lesson.title}
              </h4>
              <p style={{ margin: 0, color: "#5c6370", fontSize: "0.9rem" }}>
                {lesson.description}
              </p>
            </div>

            <Link to={`/listening/${level}/${lesson.id}`}>
              <button style={btnStyle(isCompleted)}>
                {isCompleted ? "Review" : "Start"}
              </button>
            </Link>
          </div>
        );
      })}

      <FeedbackBox skill="Listening" level={level} />
    </div>
  );
}

const cardStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "15px",
  marginBottom: "12px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #ece8fb",
  boxShadow: "0 6px 16px rgba(45,37,89,0.08)",
};

const btnStyle = (done) => ({
  backgroundColor: done ? "#58cc6a" : "#6c4de6",
  color: "white",
  border: done ? "1px solid #48b457" : "1px solid #583bc4",
  padding: "10px 20px",
  borderRadius: "10px",
  fontWeight: "bold",
  cursor: "pointer",
  marginLeft: "10px",
});

export default ListeningLevel;